export default {
  setRows(state, rows) {
    state.rows = rows || []
  },
}

